/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Filter_PassInputs */

const en_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const de_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const fr_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const es_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const it_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const nl_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const pl_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const fi_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const da_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

const sv_portal_scanner_filter_pass = /** @type {(inputs: Portal_Scanner_Filter_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title passes the filter`)
};

/**
* | output |
* | --- |
* | "Title passes the filter" |
*
* @param {Portal_Scanner_Filter_PassInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_filter_pass = /** @type {((inputs?: Portal_Scanner_Filter_PassInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Filter_PassInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_filter_pass(inputs)
	if (locale === "fr") return fr_portal_scanner_filter_pass(inputs)
	if (locale === "es") return es_portal_scanner_filter_pass(inputs)
	if (locale === "it") return it_portal_scanner_filter_pass(inputs)
	if (locale === "nl") return nl_portal_scanner_filter_pass(inputs)
	if (locale === "pl") return pl_portal_scanner_filter_pass(inputs)
	if (locale === "fi") return fi_portal_scanner_filter_pass(inputs)
	if (locale === "da") return da_portal_scanner_filter_pass(inputs)
	if (locale === "sv") return sv_portal_scanner_filter_pass(inputs)
	return en_portal_scanner_filter_pass(inputs)
});